import * as React from 'react';

import './single-card.scss';

export default class SingleCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            children: props.children,
            width: !props.width ? '24em' : props.width,
            height: props.height,
            header: props.header,
            footer: props.footer
        };
    }

    render() {
        const { children, width, height, footer, header } = this.state;

        return (
            <div className='e-card single-card' id='basic' style={{
                width: width,
                height: height
            }}>
                {(header &&
                    <div className='e-card-header'>
                        <div className='e-card-header-caption'>
                            <div className='e-card-title'>{header}</div>
                        </div>
                    </div>
                )}

                <div className='e-card-content'>{children}</div>
                {(footer &&
                    <div className='e-card-actions'>
                        <div className='e-outline'>{footer}</div>
                    </div>
                )}
            </div>
        );
    }
}